var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLinkExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3905 2.66691L10.2498 2.66701C9.88164 2.66703 9.58315 2.36857 9.58313 2.00038C9.58311 1.63219 9.88157 1.3337 10.2498 1.33368L14.0001 1.3335C14.1769 1.33349 14.3465 1.40372 14.4716 1.52875C14.5966 1.65377 14.6668 1.82335 14.6668 2.00016V5.37523C14.6668 5.74342 14.3684 6.0419 14.0002 6.0419C13.632 6.0419 13.3335 5.74342 13.3335 5.37523V3.6095L8.09599 8.84638C7.83562 9.10671 7.41351 9.10669 7.15318 8.84632C6.89285 8.58596 6.89287 8.16385 7.15324 7.90351L12.3905 2.66691ZM4.25016 2.66683C3.37571 2.66683 2.66683 3.37571 2.66683 4.25015V11.7502C2.66683 12.6246 3.37571 13.3335 4.25016 13.3335H11.7502C12.6246 13.3335 13.3335 12.6246 13.3335 11.7502V8.75012C13.3335 8.38194 13.632 8.08346 14.0002 8.08346C14.3684 8.08346 14.6668 8.38194 14.6668 8.75012V11.7502C14.6668 13.361 13.361 14.6668 11.7502 14.6668H4.25016C2.63934 14.6668 1.3335 13.361 1.3335 11.7502V4.25015C1.3335 2.63932 2.63934 1.3335 4.25016 1.3335H7.25016C7.61835 1.3335 7.91683 1.63197 7.91683 2.00016C7.91683 2.36835 7.61835 2.66683 7.25016 2.66683H4.25016Z",
    fill: "#003193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkExternal);
export default __webpack_public_path__ + "static/media/ic-link-external.84dfb8e5f47519db46d810f2477df69f.svg";
export { ForwardRef as ReactComponent };